import { render, staticRenderFns } from "./Beer.vue?vue&type=template&id=884e3ab0&"
import script from "./Beer.vue?vue&type=script&lang=js&"
export * from "./Beer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports